// utils/RemoveCanvasWrapper.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const EXCLUDED_PATHS = ['/design-tool', '/seller/design-tool'];

const RemoveCanvasWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    const isExcluded = EXCLUDED_PATHS.some(path => location.pathname.startsWith(path));
    
    if (!isExcluded) {
      const canvasWrapper = document.querySelector('.canvas-container');
      if (canvasWrapper) {
        console.log(`✅ Removed canvas container from ${location.pathname}`);
        canvasWrapper.remove();
      }
    }
  }, [location]);

  return null;
};

export default RemoveCanvasWrapper;
